export enum JobseekerStatusEnum {
  Pending = 0,
  Active = 1,
  Inactive = 2,
  Deleted = 3,
  Rejected = 5,
}
